<template lang="pug">
//- イベント詳細ページ
.event
  .sub-page-padding
    .container
      article.event-block.article-content(v-if="event")
        .left-col
          .event-head-block
            //- 残席わずか/締切間近/Pick Up!
            ul.common-tags-lists
              li.common-tags-list(v-if="event.advertising" class="common-caution-tags") {{$t(event.advertising)}}
              //- 予約開始前/予約受付中/予約終了/満席
              template(v-if="event.reserveStatus")
                li.common-tags-list(:class="event.reserveStatus.status.name") {{$t(event.reserveStatus.status.text)}}
                li.reserveStatusReserved(v-if="event.isReserved") {{$t('予約済')}}
            .favButton(@click="toggleFavorite(event)" :class="event.isFavoritedCopy ? 'favButtonOn':'favButtonOff'")

          h1 {{event.title}}

          ImageViewerWithThumbnail(:images="event.images" :uid="event.id")

          template(v-if="!$store.state.user.authenticated")
            LoginRequired

          template(v-else)
            SectionContents(:sections="event.sections")

            HeadingBlock(level="2" text="イベント概要")
            table.article-table
              tbody
                tr
                  th {{$t("開催日")}}
                  template(v-if="(event.endDateTime - event.startDateTime) <= 86400000")
                    //- 1日開催の場合
                    td
                      //- | {{ event.startDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}〜{{ event.endDateTime | moment('HH:mm') }}
                      | {{ event.startDateTime | moment('YYYY.MM.DD(ddd)') }}
                      br
                      | {{ event.dateRemarks }}
                  template(v-else)
                    //- 期間開催の場合
                    //- ※ event.endDateTimeは当日24:00:00(つまり翌日)を含むので-1して23:59:59.99..にしている 
                    td
                      | {{ event.startDateTime | moment('YYYY.MM.DD(ddd)') }}〜{{ event.endDateTime-1 | moment('YYYY.MM.DD(ddd)') }}
                      br
                      | {{ event.dateRemarks }}
                tr
                  th {{$t("会場")}}
                  td(v-if="event.place") {{ event.place }}
                  td(v-else) {{$t("オンライン")}}
                tr
                  th {{$t("定員")}}
                  td(v-if="event.sessions && event.sessions[0] && event.sessions[0].capacity") {{event.sessions[0].capacity + $t("名様")}}
                  td(v-else) {{$t("制限なし")}} 
                tr
                  th {{$t("参加費")}}
                  td(v-if="event.price === 0") {{$t("無料")}}
                  td(v-else)
                    div {{ event.price.toLocaleString() }} {{$t("円")}}
                    //- div(v-if="!event.place") 
                    div(v-if="this.$i18n.locale === 'en'") Note: Please pay at the venue
                    div(v-else) ※ お支払いは会場でお願いします
                tr(v-if="event.extraText")
                  th {{ event.extraLabel }}
                  td {{ event.extraText }}

            //- 日ごとの表にする場合
              HeadingBlock(level="2" text="イベント概要")
              div(v-for="day in sessionsByDay")
                h3 {{ day.date | moment('YYYY.MM.DD(ddd)') }}
                table.article-table
                  tbody
                    tr(v-for="session in day.sessions")
                      th {{$t("開催日")}}
                      template(v-if="(session.endDateTime - session.startDateTime) <= 86400000")
                        //- 1日開催の場合
                        td
                          | {{ session.startDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
                          br
                          | {{ session.dateRemarks }}
                      template(v-else)
                        //- 期間開催の場合
                        td
                          | {{ session.startDateTime | moment('YYYY.MM.DD(ddd)') }}〜{{ session.endDateTime | moment('YYYY.MM.DD(ddd)') }}
                          br
                          | {{ session.dateRemarks }}
                    tr
                      th {{$t("会場")}}
                      td(v-if="event.place") {{ event.place }}
                      td(v-else) {{$t("オンライン")}}
                    tr
                      th {{$t("定員")}}
                      //- 1日開催の場合
                      td(v-if="event.holdingType === 0") {{ day.sessions[0].capacity ? day.sessions[0].capacity + $t("名様") : $t("制限なし") }} 
                      //- 期間開催の場合
                      td(v-else) {{$t("制限なし")}} 
                    tr
                      th {{$t("参加費")}}
                      td(v-if="event.price === 0") {{$t("無料")}}
                      td(v-else) {{ event.price.toLocaleString() }} {{$t("円")}}
                    tr(v-if="event.extraText")
                      th {{$t("注意事項")}}
                      td {{ event.extraText }}
              
              //- ライブラリーへのリンク(ライブラリー側から当記事が関連イベントに指定されている場合リンクを表示)
            .reltype-link(v-if="event.reportArticleID")
              router-link(:to="{name: 'library', params: {id: event.reportArticleID}}")
                button.middle-button-style.blue-button.w-100 {{$t("ライブラリー")}}

        .right-col
          .event-reservation-block
            .event-reservation-session-block
              ._block(v-for="(session, index) in event.sessions" :key="session.id")
                dl.mini-title-list
                  dt.red-ttl {{$t("開催日")}}
                  template(v-if="(session.endDateTime - session.startDateTime) <= 86400000")
                    dd {{ session.startDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
                  template(v-else)
                    dd {{ session.startDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}〜{{ session.endDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}
                  
                  template(v-if="event.reservableFlag")
                    dt.red-ttl {{$t("予約期間")}}
                    dd {{ session.reservationStartDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}〜
                      br
                      | {{ session.reservationEndDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}
                    template(v-if="session.capacity")
                      dt.blue-ttl {{$t("定員")}}
                      dd {{ session.capacity }} {{$t("名様")}}


                .reserve-button-area(v-if="$store.state.user.authenticated")
                  //- ログイン状態か

                  template(v-if="event.reservableFlag")
                    //- 予約可能イベントか
                    template(v-if="session.participant")
                      //- 予約済みならボタンの手前に予約IDを表示する
                      ._id
                        | {{$t("予約ID")}}：
                        span {{ session.participant.reservationID }}

                    //- セッション別エリア
                    //- [ボタン種類] (全5パターン)
                    //- 予約する/キャンセルする/予約期間前/予約期間終了/開催終了

                    template(v-if="now < session.reservationStartDateTime")
                      //- 予約期間前である

                      button._button.disabled.no-cursor.center(disabled) {{$t("予約期間前")}}
                        //- 予約期間前ボタン(非活性)

                    template(v-else-if="session.reservationStartDateTime <= now && now < session.reservationEndDateTime")
                      //- 予約期間中である

                      template(v-if="session.participant")
                        //- 予約済みの場合

                        button._button.cancel.center(:value="session.id" @click="cancelSessionReservation(session.id, index)")
                          span(:value="session.id") {{ session.startDateTime | moment('HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
                          span(:value="session.id") {{$t("キャンセルする")}}
                          //- キャンセルするボタン(活性)

                      template(v-else-if="session.reservedCount >= session.capacity")
                        //- 定員に達している場合

                        button._button.disabled.no-cursor.center(disabled)
                          span {{ session.startDateTime | moment('HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
                          span {{$t("満席")}}
                          //- 満席ボタン(非活性)

                      template(v-else-if="session.reservedCount < session.capacity")
                        //- 定員に達していない場合

                        button._button.center(:value="session.id" @click="reserveSession(session.id, index)")
                          span(:value="session.id") {{ session.startDateTime | moment('HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
                          span(:value="session.id") {{$t("予約する")}}
                          //- 予約するボタン(活性)

                    template(v-else-if="session.reservationEndDateTime <= now && now < session.endDateTime")
                      //- 予約終了日以降である(且つ開催終了日より前である)

                      template(v-if="session.participant")
                        //- 予約済みの場合

                        button._button.cancel.center(:value="session.id" @click="cancelSessionReservation(session.id, index)")
                          span(:value="session.id") {{ session.startDateTime | moment('HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
                          span(:value="session.id") {{$t("キャンセルする")}}
                          //- キャンセルするボタン(活性)
                          
                      template(v-else)
                        //- 予約していない場合

                        button._button.disabled.no-cursor.center(disabled) {{$t("予約期間終了")}}
                          //- 予約期間終了ボタン(非活性)

                    template(v-else-if="session.endDateTime <= now")
                      //- 開催終了後である

                      template(v-if="session.participant")
                        //- 予約済の場合

                        button._button.disabled.no-cursor.center(disabled) {{$t("開催終了")}}
                          //- 開催終了ボタン(非活性)

                      template(v-else)
                        //- 予約していない場合

                        button._button.disabled.no-cursor.center(disabled) {{$t("開催終了")}}
                          //- 開催終了ボタン(非活性)

                    template(v-else)
                      //- その他(表示されない前提)

                  template(v-else)
                    //- 予約可能イベントでない場合
                    template(v-if="session.endDateTime <= now")
                      //- 開催終了後である

                      button._button.disabled.no-cursor.center(disabled) {{$t("開催終了")}}
                        //- 開催終了ボタン(非活性)



                  transition(name="fade")
                    //- Warningテキストエリア
                    .reserve-event-status-block(v-show="warningText[index]") {{ warningText[index] }}

                .reserve-button-area(v-else)
                  //- 非ログイン状態である

            .event-share-block
              ShareButton(:fullPath="$route.fullPath", :title="event.title")

</template>

<script>
import moment from 'moment-timezone'
import mixinMetaTag from '@/mixins/metaTag.js'
import mixinEvent from '@/mixins/event.js'

import HeadingBlock from '@/components/HeadingBlock'
import LoginRequired from '@/components/LoginRequired'
import ImageViewerWithThumbnail from '@/components/ImageViewerWithThumbnail'
import SectionContents from '@/components/SectionContents'
import ShareButton from '@/components/ShareButton'

export default {
  components: {
    HeadingBlock,
    LoginRequired,
    ImageViewerWithThumbnail,
    SectionContents,
    ShareButton,
  },
  mixins: [mixinMetaTag, mixinEvent],
  data() {
    return {
      event: null,
      sessionsByDay: [],
      eventId: this.$route.params.id,
      now: 0,
      warningText: [],
    }
  },
  computed: {},
  methods: {
    init() {
      this.now = moment().valueOf()
      this.api('getEventByID', { eventID: this.eventId }, (rv) => {
        console.log(rv)
        if (!rv || !rv.succeed) {
          this.$router.push({
            path: '/notFound',
          })
        } else {
          this.event = this.parseEventData(rv.event, this.now)
          this.sessionsByDay = this.parseSessions(this.event.sessions)
          console.log('sessionsByDay', this.sessionsByDay)
          this.setArticleTitleAsMeta(this.event.title)
          this.setArticleDescriptionAsMeta(this.event.sections)
        }
      })
    },
    // sessionsを日付ごとにまとめる
    parseSessions(sessions) {
      let parsedSessions = []
      const isSameDay = (date1, date2) => {
        return moment(date1).isSame(date2, 'day')
      }
      /* output example
      [
        {
          date:xxxxx, // 当日00:00のmillisec
          sessions:[], // Session型の配列
        },
        {
          date:xxxxxx,
          sessions:[]
        }
        {
          sessions:[] // startとendが同日でないsessionの場合、dateなし
        }
      ]
      */
      sessions.forEach((session) => {
        console.log(session.startDateTime)
        if (
          parsedSessions.length === 0 ||
          !isSameDay(
            parsedSessions[parsedSessions.length - 1].date,
            session.startDateTime
          )
        ) {
          console.log('初めての日')
          // 初めて出てきた日
          if (isSameDay(session.startDateTime, session.endDateTime)) {
            parsedSessions.push({
              date: session.startDateTime,
              sessions: [session],
            })
          } else {
            console.log('1日セッションでない')
            parsedSessions.push({
              sessions: [session],
            })
          }
        } else {
          console.log('初めてじゃない日')
          // 同じ日
          if (isSameDay(session.startDateTime, session.endDateTime)) {
            // この場合parsedSessionsに追加しない
            parsedSessions[parsedSessions.length - 1].sessions.push(session)
          } else {
            console.log('1日セッションでない')
            parsedSessions.push({
              sessions: [session],
            })
          }
        }
      })
      return parsedSessions
    },
    // メソッド単体テスト用
    test_parseSessions() {
      const sessions = [
        {
          id: 1,
          startDateTime: moment('2021-01-01 09').valueOf(),
          endDateTime: moment('2021-01-01 10').valueOf(),
        },
        {
          id: 2,
          startDateTime: moment('2021-01-01 10').valueOf(),
          endDateTime: moment('2021-01-01 11').valueOf(),
        },
        {
          id: 3,
          startDateTime: moment('2021-01-01 11').valueOf(),
          endDateTime: moment('2021-01-01 12').valueOf(),
        },
        {
          id: 4,
          startDateTime: moment('2021-01-01 12').valueOf(),
          endDateTime: moment('2021-01-01 13').valueOf(),
        },
        {
          id: 5,
          startDateTime: moment('2021-01-02 12').valueOf(),
          endDateTime: moment('2021-01-04 12').valueOf(),
        },
        {
          id: 6,
          startDateTime: moment('2021-01-04 13').valueOf(),
          endDateTime: moment('2021-01-05 13').valueOf(),
        },
        {
          id: 7,
          startDateTime: moment('2021-01-05 13').valueOf(),
          endDateTime: moment('2021-01-05 15').valueOf(),
        },
        {
          id: 8,
          startDateTime: moment('2021-01-05 15').valueOf(),
          endDateTime: moment('2021-01-05 17').valueOf(),
        },
        {
          id: 9,
          startDateTime: moment('2021-01-08 10').valueOf(),
          endDateTime: moment('2021-01-08 15').valueOf(),
        },
        {
          id: 10,
          startDateTime: moment('2021-01-08 15').valueOf(),
          endDateTime: moment('2021-01-08 18').valueOf(),
        },
      ]
      const test = this.parseSessions(sessions)
      console.log(test)
    },
    reserveSession(sessionID, index) {
      console.log('予約処理開始')
      let errorText = ''
      console.log('reserveEvent', this.eventId, sessionID)
      this.api('reserveEvent', { eventID: this.eventId, sessionID }, (rv) => {
        console.log(rv)
        if (rv.succeed) {
          errorText = '予約が完了しました'
          this.$store.commit('event/resetItems')
          this.$store.commit('reservingEvent/resetItems')
        } else {
          const errors = {
            reservationNotAccepted: 'このイベントは現在予約できません',
            alreadyReserved: '予約済です',
            reservationCapacityOver: '定員に達してるため予約できませんでした',
            reservedAnotherSession: '他のセッションに既に予約済です',
          }
          errorText = errors[rv.errorCode] || '予約に失敗しました'
        }
        this.init()
        this.warningText[index] = this.$i18n.t(errorText)
      })
    },
    cancelSessionReservation(sessionID, index) {
      console.log('予約キャンセル処理開始')
      let errorText = ''
      this.api(
        'cancelEventReservation',
        { eventID: this.eventId, sessionID },
        (rv) => {
          console.log(rv)
          if (rv.succeed) {
            errorText = 'キャンセルを受け付けました'
            this.$store.commit('event/resetItems')
            this.$store.commit('reservingEvent/resetItems')
          } else {
            const errors = {
              cancellationNotAccepted: 'このイベントは現在キャンセルできません',
              noReservation: '予約がないか既にキャンセル済です',
            }
            errorText = errors[rv.errorCode] || 'キャンセルに失敗しました'
          }
          this.init()
          this.warningText[index] = this.$i18n.t(errorText)
        }
      )
    },
    // recordParticipation(eventID, sessionID) {
    //   //イベント予約用API(テスト用なので後日削除)
    //   this.api('recordParticipation', { eventID, sessionID }, rv => {
    //       console.log(rv)
    //   })
    // }
  },
  created() {
    this.init()
    //this.test_parseSessions()

    //- イベント予約用関数
    //- this.recordParticipation('b00ec20d-e929-11eb-ac47-0af363eb5062', '1800')
  },
  beforeRouteUpdate(to, from, next) {
    // URL の id が変わったときは再描画する
    this.eventId = to.params.id
    this.init()
    next()
  },
}
</script>

<style lang="scss" scoped>
.event-block {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  @include sp-layout {
    flex-direction: column;
  }
  .event-head-block {
    position: relative;
    margin-bottom: 18px;
    @include sp-layout {
      margin-bottom: 15px;
    }
    .time {
      margin-right: 10px;
    }
  }
  .left-col {
    width: 720px;
    @include sp-layout {
      width: 100%;
    }
  }
  .right-col {
    width: 280px;
    @include sp-layout {
      width: 100%;
      margin-top: 45px;
    }
  }
  .single-article-table {
    margin-bottom: 40px;
    @include sp-layout {
      margin-bottom: 32px;
    }
  }
  .favButtonOn {
    background-image: url('../../assets/images/event/favorite_on.svg');
    background-size: 18px 24px;
  }
  .favButtonOff {
    background-image: url('../../assets/images/event/favorite_off.svg');
    background-size: 18px 24px;
  }

  .event-reservation-block {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.16);
    padding: 30px 30px;
  }
  .event-reservation-session-block {
    ._block {
      margin-bottom: 28px;
      padding-top: 28px;
      &:first-child {
        padding-top: 0;
      }
      & + ._block {
        border-top: 1px solid $tags-color-gray;
      }
    }
  }
  .event-share-block {
    border-top: 1px solid $tags-color-gray;
    padding-top: 10px;
  }
  .article-table {
    margin-bottom: 64px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .reserve-event-status-block {
    font-size: 14px;
    margin-top: 8px;
    color: $base-color-red;
  }
  .event-end-block {
    margin-bottom: 25px;
  }
}
.reserve-button-area {
  ._id {
    border: 1px solid $tags-color-gray;
    padding: 10px 10px;
    font-size: 13px;
    color: $gray-color;
    margin-bottom: 10px;
    border-radius: 3px;
    span {
      color: $base-color;
    }
  }
  ._button {
    font-size: 14px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: $base-color-red;
    color: #fff;
    font-weight: bold;
    padding: 17px 15px;
    border-radius: 3px;
    text-decoration: none;
    @include link-hover();
    &.cancel {
      background-color: $tags-color-gray;
      color: $base-color;
    }
    &.disabled {
      background-color: $tags-color-gray;
      color: $gray-color;
      transition: none;
      opacity: 1;
    }
    span {
      pointer-events: none;
    }
  }
}
.event {
  .sp-footer-reserve-button-area {
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: 100%;
    padding: 10px 0;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.04);
  }
}
</style>
